import { FC, useEffect } from 'react';
import i18n, { resolveInitialLanguage } from 'i18n';
import { useFeatureFlag } from './useFeatureFlag';

export const GLOBALIZATION_FLAG = 'globalization';

export const useGlobalizationFlag = () => {
  const flag = useFeatureFlag(GLOBALIZATION_FLAG);
  return { enabled: flag.enabled, value: flag.value, isLoading: flag.value === null };
};

export const useEnforceLanguageWhenFlagOff = () => {
  const globalizationEnabled = useGlobalizationFlag();

  useEffect(() => {
    if (globalizationEnabled.isLoading) return;

    if (!globalizationEnabled.enabled && i18n.language !== 'pt-BR') {
      i18n.changeLanguage('pt-BR');
    } else {
      const initialLanguage = resolveInitialLanguage();
      i18n.changeLanguage(initialLanguage);
    }
  }, [globalizationEnabled]);
};


export const GlobalizationLanguageEnforcer: FC = () => {
  useEnforceLanguageWhenFlagOff();
  return null;
};